define('views/pages/StoreLocatorPageView',[
    'underscore',
    'jquery',
    'backbone',
    'router',
    'app',
    'TagCommander',
    'PageView',
    'models/StoreLocationModel',
    'models/StoreLocatorSearchCollection',
    'UrlFactory',
    'ApiRequest',
    'mapboxGL',
    //'mapboxJSDirection',
    'models/StoreModel',
    'InternalLinkView',
    'CSS3Events',
    'template!blocks/stores/store-loc-layout',
    'template!blocks/stores/listing-main',
    'template!blocks/stores/listing-bottom',
    'template!blocks/stores/single-main',
    'template!blocks/stores/single-bottom',
    'template!blocks/stores/stores-count',
    'template!blocks/stores/stores-breadcrumb',
    'template!blocks/stores/store-result',
    'template!blocks/stores/store-autocomplete-result',
    'template!blocks/stores/store-opening-hours',
    'template!blocks/stores/store-locator-infowindow',
    'template!blocks/stores/store-locator-infowindowint',
    'template!blocks/stores/faq',
    'template!blocks/stores/store-benefits',
    'template!blocks/stores/internal-mesh',
    'moment',
    'string',
    'IndicatorMessageView',
    'Siema',
    'models/StoreLocatorModel',
    'template!blocks/stores/store-avisverifie-comment',
    'template!blocks/avis/avis-star',
    'template!blocks/stores/store-avisverifie-filter',
    'models/StoreAvisVerifieModel',
], function (
    _,
    $,
    Backbone,
    router,
    app,
    TagCommander,
    PageView,
    StoreLocationModel,
    StoreLocatorSearchCollection,
    UrlFactory,
    ApiRequest,
    mapboxGL,
    // mapboxJSDirection,
    StoreModel,
    InternalLinkView,
    CSS3Events,
    StoreLocLayoutTemplate,
    ListingMainTemplate,
    ListingBottomTemplate,
    SingleMainTemplate,
    SingleBottomTemplate,
    StoresCountTemplate,
    StoresBreadcrumbTemplate,
    StoreResultTemplate,
    StoreAutocompleteResultTemplate,
    storeOpeningHoursTemplate,
    storeLocatorInfowindowTemplate,
    storeLocatorInfowindowTemplateInt,
    faqTemplate,
    benefitsTemplate,
    internalMeshTemplate,
    moment,
    S,
    IndicatorMessageView,
    Siema,
    StoreLocatorModel,
    StoreAvisverifieCommentsTemplate,
    AvisStarTemplate,
    StoreAvisverifieFilterTemplate,
    StoreAvisVerifieModel
) {
    // représente la page store locator
    // avec la vue liste et détail d'une boutique

    var storeLocatorModel;
    //

    // Mapbox Classes
    var turf, Map, LngLat, LngLatBounds, Marker, Popup, NavigationControl;
    function InitMapboxGL(callback, err) {
        // init Google Classes refs
        mapboxGL.init(function (mapboxGLJS, turfJS) {
            turf = turfJS;
            Map = mapboxGLJS.Map;
            LngLat = mapboxGLJS.LngLat;
            LngLatBounds = mapboxGLJS.LngLatBounds;
            Marker = mapboxGLJS.Marker;
            Popup = mapboxGLJS.Popup;
            NavigationControl = mapboxGLJS.NavigationControl;
            callback();
        }, err);
    }

    var map, markers, userpinMarker, mapPopup, destinations, focusedStore;

    var MAP_PADDING_VERTICAL_DESKTOP = 60,
        MAP_PADDING_HORIZONTAL_DESKTOP = 60,
        MAP_PADDING_VERTICAL_MOBILE = 30,
        MAP_PADDING_TOP_MOBILE = 55 + 40,
        MAP_PADDING_BOTTOM_MOBILE = 140 + 20,
        MAP_PADDING_HORIZONTAL_MOBILE = 20;

    var DELIVERY_AREA_LAYER_ID = 'deliveryAreaPolygon';
    var STORE_LOCATOR_SELECTOR = '.store-locator',
        INPUT_SEARCH_SELECTOR = '.input-search input',
        STORE_LOCATOR_MAIN_SELECTOR = STORE_LOCATOR_SELECTOR + '__main',
        STORE_LOCATOR_BOTTOM_SELECTOR = STORE_LOCATOR_SELECTOR + '__bottom',
        STORE_LOCATOR_TITLE_SELECTOR = STORE_LOCATOR_SELECTOR + '__title',
        STORE_LOCATOR_SUBTITLE_SELECTOR = STORE_LOCATOR_SELECTOR + '__subtitle';
    var LIST_AVIS_CONTAINER_SELECTOR = '.single-store__avis-verbatims--list';
    var LIST_AVIS_FILTER_CONTAINER_SELECTOR =
        '.single-store__avis-verbatims--filter';
    var page_type_state;

    function easeNone() {
        return 1;
    }

    function fitBoundsOptions(options) {
        var isMobile = app.isMobile(),
            isBounds = storeLocatorModel.get('type') === 'bounds',
            isSingle = storeLocatorModel.isSingle();
        return _.defaults(options, {
            animate: !isMobile,
            padding: {
                top: isBounds
                    ? 0
                    : isMobile
                    ? isSingle
                        ? MAP_PADDING_VERTICAL_MOBILE
                        : MAP_PADDING_TOP_MOBILE
                    : MAP_PADDING_VERTICAL_DESKTOP,
                bottom: isBounds
                    ? 0
                    : isMobile
                    ? isSingle
                        ? MAP_PADDING_VERTICAL_MOBILE
                        : MAP_PADDING_BOTTOM_MOBILE
                    : MAP_PADDING_VERTICAL_DESKTOP,
                left: isBounds
                    ? 0
                    : isMobile
                    ? MAP_PADDING_HORIZONTAL_MOBILE
                    : MAP_PADDING_HORIZONTAL_DESKTOP,
                right: isBounds
                    ? 0
                    : isMobile
                    ? MAP_PADDING_HORIZONTAL_MOBILE
                    : MAP_PADDING_HORIZONTAL_DESKTOP,
            },
        });
    }

    var storeLocatorSearch = new StoreLocatorSearchCollection();

    var defaultFilters = {
            type: -1,
            benefit: [],
        },
        currentFilter = defaultFilters;
    var currentStarFilter = 0;

    var StoreLocatorPageView = PageView.extend({
        pageName: 'Store',
        events: {
            'submit .input-search': 'submitSearch',
            'click .reset-search': 'resetSearch',
            'click .link.city': 'getCity',
            'click .btn.geolocate': 'geolocate',
            'click .stores-counts .count': 'filterByType',
            'click .store-result a': 'trackStoreClick',
            'input .input-search input': 'inputChange',
            'focusout .input-search input': 'inputChange',
            'focusin .input-search input': 'inputFocus',
            'click .gotoshop': 'storeClickAndCollect',
            'click .listing-stores__buttons button': 'changeMobileTab',
            'keyup .input-search input': 'keyUpSearch',
            'click .search-in-area': 'searchInArea',
            'click .filters-benefits__button': 'toggleFilters',
            'focusout .filters-benefits': 'toggleFilters',
            'click .filters-benefits__item': 'filterByBenefit',
            'click .head__avisverifie .avisverifie__nbr': 'scrollIntoAvis',
            'click .avis-dropdown-filter__item': 'filterAvisByStar',
            'click .avisverifie-comments__content': 'toggleTwoLineParagraph',
            'click .avisverifie-comments__show-more': 'toggleShowMoreComments',
            'click .avisverifie-comments__show-less': 'toggleShowMoreComments',
            'click .avisverifie-comments__info-bulle': 'displayControlModal',
            'click .avisverifie-comments__avis-controle': 'displayControlModal',
        },
        initialize: function (options) {
            var view = this,
                data = view.$(STORE_LOCATOR_SELECTOR).data();
            map = false;
            destinations = false;
            page_type_state = 'default';
            if (!!data) {
                // indique qu'un DOM est pré-existant
                data.domReady = true;
            }

            storeLocatorModel = StoreLocatorModel.getInstance();
            storeLocatorModel.preset(_.defaults(options, data));

            // PageView constructor heritage
            PageView.prototype.initialize.apply(view, arguments);

            view.listenTo(view, 'filterChange', view.onFilterChange);
            view.listenTo(view, 'focusStore', view.focusStore);
            view.listenTo(
                storeLocatorModel,
                'dataReady',
                view.onSyncExceptionnalClosure
            );
            view.listenTo(
                app.getStores(),
                'exceptionnalClosure',
                view.onSyncExceptionnalClosure
            );
            if (app.isMobile())
                view.listenTo(app, 'change:winH', view.onResize);
            storeLocatorSearch.initStoreLocator(storeLocatorModel);
            storeLocatorSearch.reset();
            //
            //
        },
        onSyncExceptionnalClosure: function () {
            if (
                !storeLocatorModel.isSingle() &&
                storeLocatorModel.get('dataReady')
            ) {
                this.renderListingContextual();
            }
        },
        microtemplate: function (options) {
            //
            var view = this,
                subpage = options.subpage;
            view.pageOptions = _.defaults(options,{});;
            storeLocatorModel.preset(options);
            storeLocatorModel.resetPageData();
            view.initialMetaTitle();

            view.$(STORE_LOCATOR_SELECTOR).attr('data-template', subpage);
            view.toggleInArea(true);
            view.cleanDeliveryArea();

            view.renderSubpage();
            if (subpage === 'listing') {
                // cas où on bascule sur le listing / recherche
                view.removeDestination();
                view.renderListingContextual();
                view.fitBounds();
                view.initFilters();
            } else {
                // cas où on bascule sur la fiche boutique
                view.renderSingleContextual();
                if (app.isDesktop()) {
                    view.focusStore(false);
                    //view.addDestination();
                }
            }
            view.drawMarkers();
            view.renderGenericContextual();
            view.toggleMobileMap(subpage);

            app.scrollTop(0);

            InternalLinkView.initializeLinksOfView(view);
        },
        initialRender: function () {
            var view = this;
            // preload
            if (!storeLocatorModel.get('domReady')) {
                view.$el.html(
                    '<div class="store-locator"><div class="store-locator__bg"><img src="' +
                        THEME_URL +
                        'medias/img/store-bg.jpg" alt="" width="1440" height="860" /><div class="loader abs playing"></div></div></div>'
                );
            }
            InitMapboxGL(
                function () {
                    StoreLocationModel.InitMapboxGL(function () {
                        storeLocatorModel.resetPageData();
                        view.render();
                        view.initialMetaTitle();
                        view.listenTo(
                            storeLocatorSearch,
                            'reset searchComplete sync',
                            view.onSearchResults
                        );
                    });
                },
                function () {
                    // TODO gestion d'un blockage MapBox
                    app.alert();
                }
            );
        },
        render: function () {
            var view = this;
            storeLocatorModel.resetPageData();
            // fonction du rendu initial

            var isSingle = storeLocatorModel.isSingle(),
                templateOptions = storeLocatorModel.getTemplateDatas();
            var main,
                bottom,
                subpage = storeLocatorModel.get('subpage');

            switch (subpage) {
                case 'listing':
                    main = ListingMainTemplate(templateOptions);
                    bottom = ListingBottomTemplate(templateOptions);
                    break;
                case 'single':
                    main = SingleMainTemplate(templateOptions);
                    bottom = SingleBottomTemplate(templateOptions);
                    break;
            }
            view.$el.html(
                StoreLocLayoutTemplate({
                    storeloc_template: subpage,
                    breadcrumb: StoresBreadcrumbTemplate(templateOptions),
                    main: main,
                    bottom: bottom,
                })
            );

            if (isSingle) {
                view.renderSingleContextual();
            } else {
                view.renderListingContextual();
            }

            view.renderMap();

            // view.renderMap();
            var links = InternalLinkView.initializeLinksOfView(view);
        },
        renderSingleContextual: function () {
            var view = this,
                store = storeLocatorModel.getStore();

            focusedStore = store.id;
            view.updateStoreDist(store);
            view.listenToOnce(store, 'sync', view.onStoreSync);
            if (mapPopup) {
                mapPopup.remove();
            }
            store.fetch();
            store.fetchAvisVerifie(function () {
                view.renderListAvis(store.lastAvisVerifie());
                var states = store.getAvisStates();
                view.renderAvisFilter(states);
            });
        },
        renderListAvis: function (list) {
            var view = this,
                store = storeLocatorModel.getStore();

            view.$(LIST_AVIS_CONTAINER_SELECTOR).html(
                StoreAvisverifieCommentsTemplate({
                    list: list,
                    certificateUrl: store.getAvisCertificateUrl(),
                })
            );
            setTimeout(function () {
                view.findEllispe();
            }, 200);
        },
        renderAvisFilter: function (states) {
            this.$(LIST_AVIS_FILTER_CONTAINER_SELECTOR).html(
                StoreAvisverifieFilterTemplate({ states: states })
            );
        },
        renderListingContextual: function () {
            // rendu de la liste des boutiques
            var view = this,
                results = view.$('.results'),
                rawHtml = '',
                storeLocation = storeLocatorModel.get('storeLocation'),
                storeTypesCounts = storeLocatorModel.getStoreTypesCounts(),
                templateDatas = storeLocatorModel.getTemplateDatas(),
                inputText = templateDatas.label,
                stores = storeLocation.getMatchingStores(),
                filteredStores = storeLocatorModel.getFilteredResults(
                    currentFilter,
                    stores
                );
            // on remet les compteurs à zero
            storeTypesCounts.each(function (type) {
                type.val = 0;
            });

            if (!!filteredStores) {
                filteredStores.each(function (store, index) {
                    storeTypesCounts._wrapped[store.get('type_shop')].val++;
                    rawHtml += StoreResultTemplate({
                        store: store,
                        index: index + 1,
                    });
                });
            } else {
                rawHtml += StoreResultTemplate({ store: null });
            }
            results.html(rawHtml);
            view.mobileScrollListener();
            view.updateStoreDist();
            results
                .find('.store-result a')
                .click($.proxy(view.trackStoreClick, view));
            storeTypesCounts.each(function (storeType) {
                view.$('.filters-store-types .' + storeType.type).attr({
                    'data-nb': storeType.val,
                });
            });
            view.$('.reset-search').toggleClass(
                'visible',
                !storeLocation.isEmpty()
            );
            view.$(INPUT_SEARCH_SELECTOR).val(inputText);

            InternalLinkView.initializeLinksOfEl(results);
        },
        resize: function () {
            if (map) {
                var view = this;
                setTimeout(function () {
                    //
                    // fonction utilisé uniquement pour corriger le bug de la carte qui se redimensionne
                    //
                    var padding = fitBoundsOptions().padding;
                    map.resize();
                    map.setPadding(padding);
                    view.focusStore();
                }, 100);
            }
        },
        onResize: function () {
            // tricky trick
            setTimeout(function () {
                if (map) {
                    map.resize();
                }
            }, 2000);
        },
        renderSubpage: function () {
            // permet de mettre à jour lors d'un changement listing <-> single
            //
            var view = this,
                isSingle = storeLocatorModel.isSingle(),
                templateDatas = storeLocatorModel.getTemplateDatas();

            templateDatas.updated = true;

            var main = (isSingle ? SingleMainTemplate : ListingMainTemplate)(
                    templateDatas
                ),
                bottom = (
                    isSingle ? SingleBottomTemplate : ListingBottomTemplate
                )(templateDatas);
            view.$(STORE_LOCATOR_MAIN_SELECTOR).html(main);
            view.$(STORE_LOCATOR_BOTTOM_SELECTOR).html(bottom);
        },
        renderGenericContextual: function () {
            // permet de mettre à jour lors d'un changement quel qu'il soit
            //
            var view = this,
                mapType = view.$(STORE_LOCATOR_SELECTOR + '__map').data('type'),
                templateDatas = storeLocatorModel.getTemplateDatas();
            //  met à jour le fil d'ariane
            view.refillBreadcrumb();
            // les titres
            view.$(STORE_LOCATOR_TITLE_SELECTOR).text(templateDatas.title);
            view.$(STORE_LOCATOR_SUBTITLE_SELECTOR).text(
                templateDatas.subtitle
            );
            // le listing de la carte mobile
            view.$('.map-list').toggleClass(
                'hide',
                storeLocatorModel.isSingle() || page_type_state !== 'map'
            );
        },
        refillBreadcrumb: function () {
            // met à jour le fil d'arianne
            var view = this,
                $breadcrumb = view.$('.breadcrumb');
            $breadcrumb.html(
                StoresBreadcrumbTemplate(storeLocatorModel.getTemplateDatas())
            );
            view.attachViews(
                InternalLinkView.initializeLinks($breadcrumb.find('a'))
            );
        },
        showStoreClosure: function (store) {
            var view = this;
            //
            // Affichage de status fermeture
            //
            ApiRequest(
                'StoreClosure',
                {},
                { id_store: store.id },
                { method: 'GET' }
            ).done(function (data) {
                var stateMessage,
                    stateCode,
                    DATETIME_TRANSLATION_CONTEXT = 'Datetime',
                    next = _(data.next || []);
                store.set('closure', data);
                stateCode = store.getNextOpening('code');
                stateMessage = store.getNextOpening();
                stateMessage =
                    '<span class="opening" data-code="' +
                    stateCode +
                    '">' +
                    stateMessage +
                    '</span>';
                view.$('.head__opening').html(stateMessage);
                //
                next.each(function (next_event) {
                    var is_ponct = next_event.timemode === 'ponct',
                        message_detail = next_event.message,
                        message_period = '',
                        days_impacted = [];

                    if (is_ponct) {
                        // fermeture ponctuelle
                        var i,
                            start = moment(next_event.from),
                            finish = moment(next_event.to),
                            startTime = start.format('LT'),
                            startDay = start.format('ll'),
                            finishTime = finish.format('LT'),
                            finishDay = finish.format('ll'),
                            start0000 = start.format('Hm') === '00',
                            finish2359 = finish.format('Hm') === '2359',
                            start_day = start.day(),
                            finish_day = finish.day(),
                            rolling_sunday = finish_day < start_day, // si le jour de rouverture est avant celui de fermeture
                            sameDay = start.isSame(finish, 'day');
                        for (
                            i = start_day;
                            i <= (rolling_sunday ? 6 : finish_day);
                            i++
                        ) {
                            days_impacted.push(i);
                        }
                        if (rolling_sunday) {
                            // en cas de passage au chevauchement du dimanche
                            for (i = 0; i <= finish_day; i++) {
                                days_impacted.push(i);
                            }
                        }
                        if (sameDay) {
                            if (start0000 && finish2359) {
                                message_period = app.t(
                                    'le %s',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    [startDay]
                                );
                            } else if (start0000) {
                                message_period = app.t(
                                    'le %s jusqu’à %s',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    [startDay, finishTime]
                                );
                            } else if (finish2359) {
                                message_period = app.t(
                                    'le %s à partir de %s',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    [startDay, startTime]
                                );
                            } else {
                                message_period = app.t(
                                    'le %s de %s à %s',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    [startDay, startTime, finishTime]
                                );
                            }
                        } else {
                            if (start0000 && finish2359) {
                                message_period = app.t(
                                    'du %s au %s',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    [startDay, finishDay]
                                );
                            } else {
                                message_period = app.t(
                                    'du %s à %s au %s à %s',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    [startDay, startTime, finishDay, finishTime]
                                );
                            }
                        }
                    } else {
                        // fermeture récurrente
                        var message_period_parts = [];
                        _(next_event.days).each(function (d) {
                            var dayMoment = moment(),
                                day = parseInt(d.day_number),
                                message_period_part,
                                closed_am = true;
                            dayMoment.day(day);
                            days_impacted.push(day);
                            message_period_part = '';
                            _(['am', 'pm']).each(function (period) {
                                var is_am = period === 'am',
                                    time_deb = d['time_deb_' + period],
                                    time_end = d['time_end_' + period],
                                    time_deb_0000 = time_deb === '00:00',
                                    is_closed = d['is_closed_' + period],
                                    closed_am_before_pm =
                                        !is_am && closed_am
                                            ? ' ' + app.t('et', 'UI') + ' '
                                            : '';
                                if (is_closed) {
                                    if (
                                        d['is_closed_am'] &&
                                        d['is_closed_pm']
                                    ) {
                                        message_period_part = app.t(
                                            'toute la journée',
                                            DATETIME_TRANSLATION_CONTEXT
                                        );
                                    } else {
                                        message_period_part +=
                                            closed_am_before_pm +
                                            app.t(
                                                is_am ? 'le matin' : 'le soir',
                                                DATETIME_TRANSLATION_CONTEXT
                                            );
                                    }
                                } else if (time_deb && time_end) {
                                    if (time_deb_0000) {
                                        message_period_part +=
                                            closed_am_before_pm +
                                            app.t(
                                                'jusqu’à %s',
                                                DATETIME_TRANSLATION_CONTEXT,
                                                [time_end]
                                            );
                                    } else {
                                        message_period_part +=
                                            closed_am_before_pm +
                                            app.t(
                                                'de %s à %s',
                                                DATETIME_TRANSLATION_CONTEXT,
                                                [time_deb, time_end]
                                            );
                                    }
                                } else {
                                    closed_am = false;
                                }
                            });
                            message_period_part =
                                app.t(
                                    'les %s (jour de la semaine)',
                                    DATETIME_TRANSLATION_CONTEXT,
                                    dayMoment.format('dddd')
                                ) +
                                ' ' +
                                message_period_part;
                            message_period_parts.push(message_period_part);
                        });
                        message_period = message_period_parts.join(', ');
                    }

                    view.$('.single-store__head').append(
                        '<div class="store-locator__closedMessage">' +
                            '<span class="indicator__icon icon-error"></span>' +
                            '<span class="store-locator__closedMessage__period">' +
                            message_period +
                            '</span> ' +
                            '<span class="store-locator__closedMessage__detail">' +
                            message_detail +
                            '</span> ' +
                            '</div>'
                    );

                    days_impacted.forEach(function (day, i) {
                        var slot = view.$(
                            '.opening_hour[data-day="' + day + '"]'
                        );

                        if (!slot.hasClass('closed')) {
                            slot.find('.day').after(
                                '<span class="indicator__icon icon-error"></span>'
                            );
                            slot.addClass('closed');
                        }
                    });
                });
            });
        },
        showStoreMessage: function (store) {
            var storeMessageCollection = store.getMessages(),
                view = this;

            if (!storeMessageCollection) {
                return;
            }

            storeMessageCollection.once('sync', function () {
                view.attachView(
                    new IndicatorMessageView('shop_info', {
                        messages: storeMessageCollection,
                    })
                );
            });
            storeMessageCollection.fetchStore({ id_store: store.id });
        },
        fitBounds: function () {
            if (map) {
                var storeLocation = storeLocatorModel.get('storeLocation'),
                    resultType = storeLocatorModel.get('type'),
                    isBounds = resultType === 'bounds',
                    resultBounds = storeLocation.getResultBounds(),
                    options;
                if (isBounds) {
                    options = fitBoundsOptions({
                        padding: {
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                        },
                    });
                } else if (resultType === 'shop') {
                    return this.focusStore();
                } else {
                    options = fitBoundsOptions();
                }

                try {
                    map.fitBounds(resultBounds, options);
                } catch (err) {
                }
            }
        },
        focusStore: function (id_store, options) {
            var view = this,
                store,
                params = { essential: false };
            if (id_store) {
                store = app.getStore(id_store);
            } else {
                store = storeLocatorModel.getStore();
            }
            if (!store) {
                return;
            }

            focusedStore = store.id;

            if (storeLocatorModel.isSingle()) {
                store.setDeliveryAreas();
                var deliveryAreas = store.getDeliveryAreas(),
                    deliveryAreasBbox = store.getDeliveryAreasBbox();
                if (deliveryAreas && deliveryAreas.features.length) {
                    view.drawDeliveryAreas(store);
                    map.fitBounds(deliveryAreasBbox, fitBoundsOptions(options));
                    return;
                }
            }
            params = _.defaults(
                options,
                {
                    animate: !app.isMobile(),
                    center: new LngLat(
                        store.getLongitude() || 0,
                        store.getLatitude() || 0
                    ),
                    zoom: 14,
                },
                params
            );
            map.flyTo(params);

            view.getMapGeoJson();
            view.drawMarkers();
        },
        renderErrorMap: function (store) {
            // si mapbox n'est pas chargé (AdBlock…)
            var view = this;
            if (view.subpage === 'list') {
                view.$('.sidebar-search').remove();
                var allStoresLi = '';
                app.getStores().each(function (s) {
                    allStoresLi += StoreResultTemplate({ store: s });
                });
                view.$('.map').remove();
                view.$('.results').html(allStoresLi);
                view.initializeLinksOfPage();
            } else {
                view.$('.getting-there').hide();
            }
        },

        renderMap: function () {
            var view = this,
                mapContainer = view.$(STORE_LOCATOR_SELECTOR + '__map');
            if (!mapContainer.is(':visible')) return;
            view.$('.loader.abs').remove();
            var mapEl = view.$('.map').get(0),
                storeLocation = storeLocatorModel.get('storeLocation'),
                mapOptions = {
                    bounds: storeLocation.get('resultBounds'),
                    fitBoundsOptions: fitBoundsOptions({}),
                },
                mapStyle = app.c(
                    '_MAPBOX_STYLES_URL_',
                    'mapbox://styles/mapbox/streets-v9'
                );
            map = new Map(
                _.defaults(mapOptions, {
                    maxZoom: 16,
                    container: mapEl,
                    style: mapStyle,
                })
            );
            map.on('load', function () {
                mapPopup = new Popup({ offset: [0, -50], anchor: 'bottom' });
                mapPopup.on('open', function () {
                    InternalLinkView.initializeLinksOfEl(mapPopup._content);
                });

                // position de l'utilisateur
                var el = document.createElement('div');
                el.className = 'store-locator__map__userpin';
                userpinMarker = new Marker(el);
                //
                if (map.getLayer('userpin')) {
                    map.removeLayer('userpin');
                }
                map.addSource('userpin', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: [
                            {
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: [],
                                },
                                properties: {
                                    title: 'Position',
                                },
                            },
                        ],
                    },
                });

                function drawUserPosition() {
                    if (!map.getLayer('userpin')) {
                        map.addLayer({
                            id: 'userpin',
                            type: 'circle',
                            source: 'userpin',
                            paint: {
                                'circle-radius': {
                                    base: 4,
                                    stops: [
                                        [6, 4],
                                        [10, 8],
                                        [22, 180],
                                    ],
                                },
                                'circle-color': '#007aff',
                                'circle-stroke-width': 2,
                                'circle-stroke-color': '#ffffff',
                            },
                        });
                    }
                }
                //

                function updateUserPosition() {
                    if (app.hasGeolocation()) {
                        var latitude = app.get('latitude'),
                            longitude = app.get('longitude'),
                            source = map.getSource('userpin'),
                            sourceData = source.serialize().data;
                        userpinMarker
                            .setLngLat(new LngLat(longitude, latitude))
                            .addTo(map);
                        sourceData.features[0].geometry.coordinates = [
                            longitude,
                            latitude,
                        ];
                        source.setData(sourceData);
                        drawUserPosition();
                    }
                }
                view.listenTo(app, 'geolocate', updateUserPosition);
                view.listenTo(app, 'geolocation', updateUserPosition);

                if (storeLocatorModel.isSingle()) {
                    view.focusStore(false, { animate: false });
                    // view.addDestination();
                } else {
                    view.listenTo(
                        app,
                        'geolocate',
                        view.renderListingContextual
                    );
                    view.listenTo(
                        app,
                        'geolocation',
                        view.renderListingContextual
                    );
                }
                view.drawMarkers();
                app.requestGeolocation();

                document.addEventListener('resize', view.resize);
            });
            function dragAndZoom(e) {
                if (e.originalEvent) {
                    // on affiche le bouton uniquement sur le listing
                    // et si c'est lié à une interaction utilisateur
                    view.toggleInArea(storeLocatorModel.isSingle());
                }
            }
            map.on('dragend', dragAndZoom);
            map.on('zoomend', dragAndZoom);
        },

        toggleInArea: function (hide) {
            this.$('.search-in-area').toggleClass('hide', hide);
            if (!hide && app.isMobile() && page_type_state === 'map') {
                this.$('.input-search').attr('data-state', 'map-down');
            }
        },

        onStoreSync: function (store) {
            var view = this;
            //view.stopListening(store,'sync',view.onStoreSync);
            view.$('.opening-hours__list').html(
                storeOpeningHoursTemplate({ store: store })
            );
            view.$('.single-store__description').html(store.getFooterSeo());

            view.showStoreClosure(store);
            view.showStoreMessage(store);
        },

        updateStoreDist: function (store) {
            var view = this,
                // on cache si on a pas de boutique
                // ou qu'on sait que la boutique est à plus de 50km
                distance = store ? store.getDistance() : false,
                hide = !store || (distance && distance > 50),
                text = '…',
                link = '#';
            if (!hide) {
                text = distance ? store.formatDistance() : text;
                link =
                    'https://www.google.com/maps?saddr=My+Location&daddr=' +
                    store.formatAddress();
            }
            view.$('.distance-actual').text(text);
            view.$('.distance--button')
                .attr('href', link)
                .toggleClass('hide', hide);
        },

        resetSearch: function () {
            var view = this;
            app.set('storeLocatorSearch', '');
            view.$(INPUT_SEARCH_SELECTOR).val('');
            // $('.ariane').children().filter(':not(.ariane__all-shops)').remove();
        },
        // addDestination: function() {
        //     var store = storeLocatorModel.getStore();
        //     if (!store || app.isMobile()) { return }
        //     if(!destinations) {
        //         destinations = new mapboxJSDirection({
        //             language: app.getIsoLang(),
        //             accessToken: app.c('_MAPBOX_ACCESS_TOKEN_'),
        //             placeholderOrigin: app.t('Choisir un point de départ', 'Stores'),
        //             placeholderDestination: store.formatAddress(),
        //         });
        //     }
        //     map.addControl(destinations, 'top-left');
        //     setTimeout(function(){
        //         try {
        //             destinations.setDestination([store.getLongitude(), store.getLatitude()])
        //         }catch(err){
        //         }
        //     },3000);
        // },
        removeDestination: function () {
            if (!destinations) {
                return;
            }
            map.removeControl(destinations);
            destinations = undefined;
        },
        getMapGeoJson: function () {
            var view = this,
                dataStore = storeLocatorModel.getStore(),
                visibleStores;
            if (dataStore) {
                visibleStores = _([dataStore]);
            } else {
                var storeLocation = storeLocatorModel.get('storeLocation'),
                    datas = storeLocatorModel.getTemplateDatas(),
                    stores = datas.label
                        ? storeLocation.getMatchingStores()
                        : app.getStores();

                if (!datas.label || stores.size() === app.getStores().size()) {
                    var storesInt = app.getStoresInt();
                    stores = _(_.union(stores.toArray(), storesInt.toArray()));
                }
                visibleStores = storeLocatorModel.getFilteredResults(
                    currentFilter,
                    stores
                );
            }

            var result = {
                type: 'FeatureCollection',
                features: [],
            };

            // Create GeoJson
            var activeStoreFeature;
            visibleStores.each(function (store) {
                var lat = store.getLatitude(),
                    lng = store.getLongitude();
                if (_.isNaN(lat) || _.isNaN(lng))
                    return ;
                var lngLat = new LngLat(lng, lat),
                    isInternational = store.isInternational();

                var data = {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [lngLat.lng, lngLat.lat],
                    },
                    properties: {
                        shop_type:
                            isInternational || store.get('template') === 'shop'
                                ? 'store'
                                : store.get('template'),
                        id_store: store.id,
                        international: isInternational,
                        focused: focusedStore === store.id,
                    },
                };

                if (!data.properties.focused) {
                    result.features.push(data);
                } else {
                    activeStoreFeature = data;
                }
            });
            if (activeStoreFeature && result && result.features) {
                result.features.push(activeStoreFeature);
            }

            return result;
        },
        drawMarkers: function () {
            var view = this,
                geoJson = view.getMapGeoJson();

            function createMarker(store) {
                var devicePixelRatio = parseFloat(window.devicePixelRatio) || 1,
                    iconSize = app.isMobile() ? 0.6 : 0.8,
                    iconSizeSelected = app.isMobile() ? 0.8 : 1.2,
                    imgBaseWidth = 30 * iconSize * devicePixelRatio,
                    imgBaseHeight = 40 * iconSize * devicePixelRatio,
                    imgWidth = 30 * iconSizeSelected * devicePixelRatio,
                    imgHeight = 40 * iconSizeSelected * devicePixelRatio,
                    deffered = $.Deferred(),
                    iconLoadedCount = 0,
                    storeTypes = ['corner', 'travel-retail', 'store'];

                function getImageData(img, destWidth, destHeight) {
                    // Create canvas
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d'),
                        w = img.width,
                        h = img.height;
                    // Set width and height
                    canvas.width = destWidth;
                    canvas.height = destHeight;
                    //view.$('.map-images').append(canvas);

                    // Draw the image
                    ctx.drawImage(img, 0, 0, w, h, 0, 0, destWidth, destHeight);
                    return ctx.getImageData(0, 0, destWidth, destHeight);
                }

                _(storeTypes).each(function (type) {
                    var imgUrl =
                        UrlFactory.getThemeUrl() +
                        'medias/img/marker-logo-' +
                        type +
                        '.svg';
                    var img = new Image(30, 40);
                    //view.$('.map-images').append(img);
                    img.onload = function () {
                        var defaultImageData = getImageData(
                            img,
                            imgBaseWidth,
                            imgBaseHeight
                        );
                        map.addImage(type, defaultImageData);
                        var focusedImageData = getImageData(
                            img,
                            imgWidth,
                            imgHeight
                        );
                        map.addImage(type + '_focused', focusedImageData);
                        iconLoadedCount++;
                        if (iconLoadedCount === storeTypes.length) {
                            deffered.resolve();
                        }
                    };
                    img.src = imgUrl;
                });
                deffered.then(function () {
                    _(storeTypes).each(function (type) {
                        var layerID = 'shop-' + type;
                        var selectedID = 'focused_shop-' + type,
                            layerDefaultOptions = {
                                id: layerID,
                                type: 'symbol',
                                source: 'shops',
                                minzoom: 7,
                                layout: {
                                    'icon-image': type,
                                    'icon-anchor': 'bottom',
                                    'icon-allow-overlap': true,
                                    'icon-size': 1 / devicePixelRatio,
                                },
                                filter: [
                                    'all',
                                    ['==', 'shop_type', type],
                                    ['==', 'focused', false],
                                ],
                            },
                            layerSelectedOptions = _.defaults(
                                {
                                    id: selectedID,
                                    layout: _.defaults(
                                        { 'icon-image': type + '_focused' },
                                        layerDefaultOptions.layout
                                    ),
                                    filter: [
                                        'all',
                                        ['==', 'shop_type', type],
                                        ['==', 'focused', true],
                                    ],
                                },
                                layerDefaultOptions
                            );

                        function toggleCursor(e) {
                            map.getCanvas().style.cursor =
                                e.type === 'mouseenter' ? 'pointer' : '';
                        }

                        function addMarkerLayer(id, layerOptions, beforeId) {
                            if (!map.getLayer(id)) {
                                map.addLayer(layerOptions, beforeId);
                                map.on('mouseenter', id, toggleCursor);
                                map.on('mouseleave', id, toggleCursor);
                                map.on('click', id, clickOnMarker);
                            }
                        }

                        addMarkerLayer(selectedID, layerSelectedOptions);
                        addMarkerLayer(
                            layerID,
                            layerDefaultOptions,
                            'focused_shop-' + storeTypes[0]
                        );
                    });
                });
            }

            function clickOnMarker(e) {
                var feature = e.features[0],
                    properties = feature.properties,
                    international = !!properties.international,
                    id_store = properties.id_store,
                    siemaSlider = view.siemaSlider,
                    zoom = map.getZoom();
                if (!app.isMobile() && !storeLocatorModel.isSingle()) {
                    var coordinates = feature.geometry.coordinates.slice(),
                        store = international
                            ? app.getStoresInt().get(id_store)
                            : app.getStore(id_store),
                        tpl = properties.international
                            ? storeLocatorInfowindowTemplateInt
                            : storeLocatorInfowindowTemplate,
                        html = tpl({ store: store });

                    // force close previous popup
                    mapPopup.remove();
                    setTimeout(function () {
                        mapPopup
                            .setLngLat(coordinates)
                            .setHTML(html)
                            .addTo(map);
                    });
                    zoom = map.getZoom();
                } else if (siemaSlider) {
                    var wrapper = $('.map-list');
                    wrapper.find('.store-result').each(function (i, el) {
                        if (el.getAttribute('data-store') === id_store) {
                            siemaSlider.goTo(i);
                        }
                    });
                    zoom = map.getZoom() > 7 ? map.getZoom() : 7;
                }
                view.trigger('focusStore', id_store, {
                    animate: true,
                    zoom: zoom,
                });
            }

            // Add stores layout
            if (map.getSource('shops')) {
                return map.getSource('shops').setData(geoJson);
            } else {
                map.addSource('shops', {
                    type: 'geojson',
                    data: geoJson,
                    cluster: true,
                    clusterMaxZoom: 6,
                });
            }

            map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'shops',
                filter: ['has', 'point_count'],
                paint: {
                    'circle-color': '#000',
                    'circle-radius': [
                        'step',
                        ['get', 'point_count'],
                        15, // default size
                        10, // Number in cluster
                        20, // Cluster's size
                        40, // Number in cluster
                        30, // Cluster's size
                        100, // Number in cluster
                        45, // Cluster's size
                    ],
                },
            });
            map.addLayer({
                id: 'cluster_count',
                type: 'symbol',
                source: 'shops',
                filter: ['has', 'point_count'],
                paint: {
                    'text-color': '#ffffff',
                },
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-size': 12,
                },
            });

            map.addLayer({
                id: 'unclusters_shop',
                type: 'circle',
                source: 'shops',
                filter: ['!', ['has', 'point_count']],
                maxzoom: 7,
                paint: {
                    'circle-color': [
                        'match',
                        ['get', 'shop_type'],
                        'corner',
                        '#b4a895',
                        'shop',
                        '#000',
                        'travel-retail',
                        '#000',
                        '#000',
                    ],
                },
            });

            createMarker();

            _(['clusters', 'unclusters_shop']).each(function (target) {
                map.on('click', target, function (e) {
                    var currentZoom = map.getZoom();
                    map.flyTo({
                        center: e.features[0].geometry.coordinates,
                        zoom: currentZoom >= 4 ? currentZoom * 1.5 : 4,
                    });
                });
            });
        },
        submitSearch: function (e) {
            e.preventDefault();
            // todo gérer à la place un index, au lieu du first
            // simule un click
            this.$('.autocomplete-results a:first').click();
        },
        resetFilters: function () {
            currentFilter = defaultFilters;
        },
        displayEmptyResults: function (search) {
            // var view = this,
            //     allStores = app.getStores().sortBy('name'),
            //     allStoresInt = app.getStoresInt().sortBy('name');
            //
            // if(!_.isUndefined(search) && search != '' && search != 'all'){
            //     app.alert(t('La recherche ne donne aucun résultat','Stores'));
            //     allStores = [];
            // }
            // view.displayList(_.union(allStores, allStoresInt));
        },
        updateUserMarker: function () {
            if (map) {
                // TODO affiche le marker de la position utilisateur
            }
        },
        geolocate: function () {
            var view = this;
            app.once('geolocation geolocation_error', function (location) {
                view.toggleGeolocateButton(false, !location);
                if (location) {
                    view.updateUserMarker();
                    app.go('storeLocatorPosition', {
                        lat: location.latitude,
                        lng: location.longitude,
                    });
                }
            });
            view.toggleGeolocateButton(true);
            app.requestGeolocation();
        },
        toggleGeolocateButton: function (loading, error) {
            var view = this,
                btn = view.$('.btn.geolocate');
            btn.attr('disabled', !!loading);
            btn.toggleClass('error', !!error);
            btn.find('i').toggleClass('playing', !!loading); // loader
        },
        keyUpSearch: function (e) {
            this.inputChange(e);
        },
        toggleLoadingIcon: function () {
            var value = this.$(INPUT_SEARCH_SELECTOR).val();
            this.$('.store-loader').toggleClass(
                'playing',
                !!storeLocatorSearch.fetching
            );
        },
        inputChange: _.debounce(function (e) {
            var view = this;
            var focusout = e.type === 'focusout',
                autocompleteResultsEl = view.$('.autocomplete-results'),
                value = this.$(INPUT_SEARCH_SELECTOR).val();
            autocompleteResultsEl.toggleClass('focusout', focusout);
            autocompleteResultsEl.toggleClass(
                'empty',
                !(value && value.length >= 2)
            );
            if (focusout) {
                // noop
                if (page_type_state === 'map') {
                    view.resize();
                }
                //
            } else if (value && value.length >= 2) {
                // >= 2 for search by postcode
                storeLocatorSearch.search(value);
                // TODO
            } else {
                autocompleteResultsEl.html('');
            }
            view.toggleLoadingIcon();
        }, 300),
        onSearchResults: function () {
            var view = this,
                html = '',
                searchCollection = storeLocatorSearch;
            if (searchCollection.size() === 0) {
                searchCollection = searchCollection.getEmptyCollection();
            }
            searchCollection.each(function (searchModel, i) {
                if (i < 10) {
                    html += StoreAutocompleteResultTemplate(
                        searchModel.toJSON()
                    );
                }
            });
            var results = view.$('.autocomplete-results');
            results.html(html);
            view.toggleLoadingIcon();
            InternalLinkView.initializeLinksOfEl(results.get(0));
        },
        inputFocus: function (e) {
            var view = this;
            view.$(INPUT_SEARCH_SELECTOR).select();
            view.$('.autocomplete-results').removeClass('focusout');
        },
        initFilters: function (e) {
            var hasFilter =
                    currentFilter.type >= 0 || currentFilter.benefit.length > 0,
                view = this;
            if (!hasFilter) {
                return;
            }

            _(currentFilter.benefit).each(function (id) {
                view.$(
                    '.filters-benefits__item[data-benefit=' + id + ']'
                ).addClass('active-filter');
            });
            if (currentFilter.type >= 0) {
                $(view.$('.stores-counts .count')[currentFilter.type]).addClass(
                    'active-filter'
                );
            }
        },
        filterByType: function (e) {
            var view = this,
                type = $(e.currentTarget).index();

            if (currentFilter.type !== type) {
                // si c'est différent on l'utilise
                currentFilter.type = type;
            } else {
                // sinon on revient à l'état sans filtre
                currentFilter.type = -1;
            }
            view.trigger('filterChange', this);
        },
        toggleFiltersNotif: function () {
            this.$('.filters-benefits__button').toggleClass(
                'filters-active',
                currentFilter.benefit.length > 0
            );
        },
        toggleFilters: function (e) {
            if (
                e.type === 'focusout' &&
                $(e.originalEvent.relatedTarget).parents('.filters-benefits')
                    .length
            )
                return;
            this.$('.filters-benefits__dropdown').toggleClass(
                'active',
                e.type !== 'focusout' ? undefined : false
            );
        },
        filterByBenefit: function (e) {
            var view = this,
                target = $(e.currentTarget),
                benefit = target.data('benefit');
            target.toggleClass('active-filter');
            if (!currentFilter.benefit.includes(benefit)) {
                // si c'est différent on l'utilise
                currentFilter.benefit.push(benefit);
            } else {
                // sinon on revientà l'état sans filtre
                var index = currentFilter.benefit.indexOf(benefit);
                currentFilter.benefit.splice(index, 1);
            }
            view.trigger('filterChange', this);
        },
        onFilterChange: function () {
            var view = this;
            view.renderListingContextual();
            view.toggleFiltersNotif();
            view.drawMarkers();
        },
        initialMetaTitle: function () {
            var meta_title = app.c(
                    '_STORE_LOCATOR_TITLE_SEO_',
                    'Nos Restaurants Japonais & Sushi'
                ),
                datas = storeLocatorModel.getTemplateDatas();
            if (datas && datas.meta_title) meta_title = datas.meta_title;
            if (!!meta_title) {
                document.title = meta_title;
            }
        },
        searchInArea: function (e) {
            var view = this;
            view.toggleInArea(true);
            var bounds = map.getBounds(),
                bounds_rewrite =
                    bounds._ne.lat +
                    '_' +
                    bounds._ne.lng +
                    '_' +
                    bounds._sw.lat +
                    '_' +
                    bounds._sw.lng;
            app.go('storeLocatorBounds', { bounds: bounds_rewrite });
        },
        mobileScrollListener: function () {
            if (!app.isMobile() && map) return;
            var view = this;
            var parent = this.el;
            try {
                var siemaSlider = new Siema({
                    selector: this.el.querySelector('.map-list .results'),
                    duration: 300,
                    easing: 'ease-out',
                    perPage: 1.1,
                    startIndex: 0,
                    draggable: true,
                    multipleDrag: true,
                    loop: false,
                    rtl: false,
                    onChange: function (e) {
                        var currentSlide = Math.round(siemaSlider.currentSlide);
                        var slideEl = parent.querySelectorAll(
                                '.map-list .store-result'
                            )[currentSlide],
                            storeId = slideEl
                                ? slideEl.getAttribute('data-store')
                                : false,
                            initialZoom = map.getZoom();
                        if (storeId) {
                            view.trigger('focusStore', storeId, {
                                animate: true,
                                zoom: initialZoom > 7 ? initialZoom : 7,
                            });
                        }
                    },
                });
                view.siemaSlider = siemaSlider;
            } catch (err) {
            }
        },
        drawDeliveryAreas: function (store) {
            var view = this;
            var deliveryAreas = store.getDeliveryAreas();
            var deliveryAreasBbox = store.getDeliveryAreasBbox();
            var union = false,
                sideLocationConflicts = [];
            _(deliveryAreas.features).each(function (feature) {
                var coordinates = _.clone(feature.geometry.coordinates),
                    poly;
                coordinates[0].push(coordinates[0][0]);
                try {
                    poly = new turf.helpers.polygon(coordinates);
                } catch (err) {
                }
                if (!union) {
                    union = poly;
                } else {
                    try {
                        union = turf.union(union, poly);
                    } catch (err) {
                        if (err.name == 'TopologyException') {
                            sideLocationConflicts.push(poly);
                        }
                    }
                }
            });
            var yetAnotherConflict = false;
            _(sideLocationConflicts).each(function (poly) {
                try {
                    union = turf.union(union, poly);
                } catch (err) {
                    yetAnotherConflict = err;
                }
            });
            if (yetAnotherConflict) {
                app.error('StoreLocator DeliveryZoneConflicts', {
                    id_store: store.id,
                });
            }

            // Find the index of the first symbol layer in the map style

            // ajoute la zone sous les building et les routes
            view.addLayer(DELIVERY_AREA_LAYER_ID, union, 'building');
        },
        cleanDeliveryArea: function () {
            if (map && map.getLayer(DELIVERY_AREA_LAYER_ID)) {
                map.removeLayer(DELIVERY_AREA_LAYER_ID);
                map.removeSource(DELIVERY_AREA_LAYER_ID);
            }
        },
        addLayer: function (layerId, data, beforeLayerId) {
            if (map.getLayer(layerId)) {
                map.removeLayer(layerId);
                map.removeSource(layerId);
            }
            map.addLayer(
                {
                    id: layerId,
                    type: 'fill',
                    layout: {},
                    source: {
                        type: 'geojson',
                        data: data,
                    },
                    paint: {
                        'fill-color': '#CFC7BB',
                        'fill-opacity': 0.5,
                        'fill-outline-color': '#5f554b',
                    },
                },
                beforeLayerId
            );
        },
        trackStoreClick: function (e) {
            var currentTarget = e.currentTarget,
                $a = $(currentTarget);
            TagCommander.eventGA(
                currentTarget,
                'Store locator',
                'Clic shop',
                $a.find('.name').text()
            );
        },
        startPageTagCommander: function (options) {
            var view = this;
            TagCommander.LoadPage(view.pageName, {
                subpage: view.subpage,
                id_store: view.id_store,
                search: app.get('storeLocatorSearch'),
            });
        },
        toggleMobileMap: function (subpage, type) {
            if (app.isMobile()) {
                var view = this,
                    $mapContainer = view.$(STORE_LOCATOR_SELECTOR + '__map'),
                    mapInitialType = $mapContainer.data('type'),
                    $inputSearch = view.$('.input-search'),
                    transitionStep = 350;
                if (!type) {
                    if (subpage === 'listing') {
                        type = view
                            .$('.listing-stores__buttons-map')
                            .is('.active')
                            ? 'map'
                            : subpage;
                    } else {
                        type = subpage;
                    }
                }
                page_type_state = type;
                if (type === mapInitialType) return;
                $mapContainer.data('type', type);


                // 3 types : listing, single, map

                function toggleMapUi(visible) {
                    view.$('.map-list').toggleClass('hide', !visible);
                }
                function mapState(state) {

                    $mapContainer.attr('data-state', state);
                    if (state.match(/^(fixed|single)/) && map) {
                        map.resize();
                    }
                }
                function inputState(state) {

                    $inputSearch.attr('data-state', state);
                }
                function mapResize(focusStore) {
                    if (map) {
                        var padding = fitBoundsOptions().padding;
                        map.resize();
                        map.setPadding(padding);
                        if (focusStore) {
                            view.focusStore();
                        }
                    }
                }
                function mapFitBoundsTrick() {
                    if (map) {
                        // trick kickass pour forcer un fitBounds des familles.
                        view.fitBounds();
                    }
                }

                function _setTimeout(handler, timeout) {
                    setTimeout(handler, timeout);
                }

                function startTransition() {
                    // listing -> map
                    // if not 0 scrollTop 0 250ms
                    // map fixed slide-up 250ms
                    // ui visible 250ms
                    if (mapInitialType === 'listing' && type === 'map') {
                        mapState('fixed-down');
                        _setTimeout(
                            $.proxy(mapState, view, 'fixed-slide-up'),
                            transitionStep
                        );
                        _setTimeout($.proxy(mapResize, view), transitionStep);
                        _setTimeout(
                            $.proxy(inputState, view, 'map-down'),
                            transitionStep * 2
                        );
                        _setTimeout(
                            $.proxy(toggleMapUi, view, true),
                            transitionStep * 2
                        );
                        _setTimeout(
                            $.proxy(mapFitBoundsTrick, view),
                            transitionStep * 2 + 1
                        );
                    }

                    // map -> listing
                    // map slide-down 250ms
                    // map hidden + ui hidden 0ms
                    if (mapInitialType === 'map' && type === 'listing') {
                        toggleMapUi(false);
                        inputState('map-up');
                        _setTimeout(
                            $.proxy(mapState, view, 'fixed-slide-down'),
                            transitionStep
                        );
                        _setTimeout(
                            $.proxy(inputState, view, 'listing'),
                            transitionStep
                        );
                        _setTimeout(
                            $.proxy(mapState, view, 'listing'),
                            transitionStep * 2
                        );
                    }

                    // map -> single
                    // ui hidden 250ms
                    // map fixed to relative JS 250ms
                    if (mapInitialType === 'map' && type === 'single') {
                        toggleMapUi(false);
                        inputState('map-up');
                        _setTimeout(
                            $.proxy(function () {
                                var mapHeight = $mapContainer.height();
                                mapState('single');
                                $mapContainer.css({
                                    height: mapHeight,
                                    transform:
                                        'translate(0,' +
                                        -$mapContainer.offset().top +
                                        'px)',
                                });
                                _setTimeout(function () {
                                    mapState('single-from-map');
                                    $mapContainer.attr('style', false);
                                }, 1);
                                $mapContainer.one(
                                    CSS3Events('transitionend'),
                                    function () {
                                        mapResize(true);
                                        mapState('single');
                                        //view.addDestination();
                                    }
                                );
                            }),
                            transitionStep
                        );
                        _setTimeout(
                            $.proxy(inputState, view, 'single'),
                            transitionStep
                        );
                    }

                    // listing -> single
                    // if not 0 scrollTop 0 250ms
                    // map visible 0ms
                    // translate legacy clone 250ms
                    // remove legacy clone
                    if (mapInitialType === 'listing' && type === 'single') {
                        mapResize(true);
                    }

                    // single -> map
                    // if not 0 scrollTop 0 250ms
                    // map relative to fixed JS 250ms
                    // ui visible 250ms
                    if (mapInitialType === 'single' && type === 'map') {
                        _setTimeout(
                            $.proxy(function () {
                                mapState('single-to-map');
                                $mapContainer.css({
                                    height: app.$window.height() - 55,
                                    transform:
                                        'translate(0,' +
                                        -$mapContainer.offset().top +
                                        'px)',
                                });
                                $mapContainer.one(
                                    CSS3Events('transitionend'),
                                    function () {
                                        mapResize(true);
                                        $mapContainer.attr('style', false);
                                        mapState('fixed-up');
                                        inputState('map-down');
                                        toggleMapUi(true);
                                    }
                                );
                            }),
                            transitionStep
                        );
                    }

                    // single -> listing
                    // if not 0 scrollTop 0 250ms
                    // translate legacy clone with attached map 250ms
                    // detach map from clone 0ms
                    // hide map 0ms
                }

                if (app.$window.scrollTop()) {
                    app.scrollTop(0, 250);
                    _setTimeout(startTransition, 250);
                } else {
                    startTransition();
                }
            }
        },
        changeMobileTab: function (e) {
            var view = this,
                $target = $(e.currentTarget),
                listingDisplayType = $target.data('value');
            view.$('.listing-stores__buttons .active').removeClass('active');
            $target.addClass('active');
            view.toggleMobileMap('listing', listingDisplayType);
            // Reset Scroll
            // view.$el.scrollTop(0);
            //view.$('.listing-stores').scrollTop(0);
        },
        storeClickAndCollect: function () {
            var view = this,
                cart = app.getCart(),
                params = {
                    id_store: storeLocatorModel.getStore().id,
                    vae: 1,
                };
            view.$('.gotoshop')
                .toggleClass('loading', true)
                .attr('disabled', true);
            view.listenToOnce(cart, 'deliveryUpdate', function () {
                app.go('listing');
            });
            cart.setDeliveryOptions(params);
        },
        scrollIntoAvis: function () {
            var el = this.$('#single-store__avis-verbatims').get(0);
            if (el)
                el.scrollIntoView({
                    behavior: 'smooth',
                    top: '50px',
                });
        },
        filterAvisByStar: function (e) {
            var view = this,
                target = $(e.currentTarget),
                star = target.data('value'),
                store = storeLocatorModel.getStore();
            $('.avis-dropdown-filter__item.active').removeClass('active');

            if (currentStarFilter !== star) {
                currentStarFilter = star;
                target.toggleClass('active', true);
            } else {
                star = 0;
                currentStarFilter = '';
                target.toggleClass('active', false);
            }
            var avisVerifieModel = new StoreAvisVerifieModel({
                id_store: store.id,
                starFilter: star,
            });
            avisVerifieModel.fetch();

            view.listenToOnce(avisVerifieModel, 'sync', function (avisVerifie) {
                var filterRes = avisVerifie.getComments();
                view.renderListAvis(_(filterRes));
            });
        },
        toggleTwoLineParagraph: function (e) {
            var target = e.currentTarget;
            $(target).toggleClass('two-line-paragraph');
        },
        findEllispe: function () {
            function isEllipsisActive(e) {
                return e.offsetHeight < e.scrollHeight;
            }

            $('.two-line-paragraph').each(function (i, e) {
                if (isEllipsisActive(e)) {
                    $(e).addClass('ellipse-enabled');
                }
            });
        },
        toggleShowMoreComments: function (e) {
            $('.avisverifie-comments').toggleClass('show-less');
        },
        displayControlModal: function () {
            app.alert({
                title: app.t('Avis soumis à un contrôle', 'avisverifie'),
                subtitle:
                    '<div class="avis-control-content">' +
                    app.c('_INFO_AVIS_VERIFIE_', '') +
                    '</div>',
            });
        },
    });

    return StoreLocatorPageView;
});

